import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
} from '@chakra-ui/react';
import { CommercialPropertyInfoEstateCompilationAreas } from '@habity/types/vitec/common/commercialPropertyInfoEstateCompilationAreas';
import { CommercialPropertyInfoEstateCompilationArea } from '@habity/types/vitec/common/commercialPropertyInfoEstateCompilationArea';
import { getOperationCost } from '@habity/services';

interface CompilationAreasTableProps {
  compilationAreas: CommercialPropertyInfoEstateCompilationAreas;
}

const getSwedishAreaName = (areaType: string): string => {
  switch (areaType) {
    case 'residential':
      return 'Bostäder';
    case 'garage':
      return 'Garage';
    case 'parkingLot':
      return 'P-platser';
    case 'office':
      return 'Kontor';
    case 'stores':
      return 'Butiker';
    case 'industry':
      return 'Industri';
    case 'warmStockroom':
      return 'Varmförråd';
    case 'coldStockroom':
      return 'Kallförråd';
    case 'other1':
      return 'Källarplan';
    case 'other2':
      return 'Studentrum';
    default:
      return areaType;
  }
};

export const CompilationAreasTable: React.FC<CompilationAreasTableProps> = ({
  compilationAreas,
}) => {
  const areaTypes = [
    'residential',
    'garage',
    'parkingLot',
    'office',
    'stores',
    'industry',
    'warmStockroom',
    'coldStockroom',
    'other1',
    'other2',
  ];

  const tableRows = areaTypes
    .map((areaType) => {
      const areaData = compilationAreas[
        areaType as keyof typeof compilationAreas
      ] as CommercialPropertyInfoEstateCompilationArea;

      if (
        areaData &&
        (areaData.number ||
          areaData.area ||
          areaData.rentalIncome ||
          areaData.otherIncome)
      ) {
        return {
          type: getSwedishAreaName(areaType),
          number: areaData.number,
          area: areaData.area,
          rentalIncome: areaData.rentalIncome,
          otherIncome: areaData.otherIncome,
        };
      }
      return null;
    })
    .filter(Boolean);

  if (tableRows.length === 0) {
    return null;
  }

  return (
    <TableContainer>
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>Typ</Th>
            <Th isNumeric>Antal</Th>
            <Th isNumeric>Area</Th>
            <Th isNumeric>Hyresintäkt/år</Th>
            <Th isNumeric>Övriga intäkter</Th>
          </Tr>
        </Thead>
        <Tbody>
          {tableRows.map((row, index) => {
            if (!row) return null;
            return (
              <Tr key={index}>
                <Td>{row.type}</Td>
                <Td isNumeric>{row.number || '-'}</Td>
                <Td isNumeric>
                  {row.area ? `${row.area.toLocaleString('sv-SE')} kvm` : '-'}
                </Td>
                <Td isNumeric>
                  {row.rentalIncome
                    ? getOperationCost(row.rentalIncome, false)
                    : '-'}
                </Td>
                <Td isNumeric>
                  {row.otherIncome
                    ? getOperationCost(row.otherIncome, false)
                    : '-'}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
